import BaseEntity from './BaseEntity';
import Issue from './Issue';
export default class RawReport extends BaseEntity {
    constructor(data) {
        super();
        this.issues = [];
        this.languages = null;
        this.output = null;
        this.errorCount = this.parseProperty(data, 'errorCount');
        this.id = this.parseProperty(data, 'id');
        if ('issues' in data && data.issues) {
            this.issues = this.parseProperty(data, 'issues').map(issue => new Issue(issue));
        }
        if ('languages' in data && data.languages) {
            this.languages = this.parseProperty(data, 'languages');
        }
        this.output = this.parseProperty(data, 'output');
        this.status = this.parseProperty(data, 'status');
        this.tool = this.parseProperty(data, 'tool');
        this.toolVersion = this.parseProperty(data, 'toolVersion');
        this.warningCount = this.parseProperty(data, 'warningCount');
    }
}
